$ = jQuery;
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.load-more');
  if (!btn) return;

  const wrapper = btn.closest('.load-more-wrapper');
  const nextUrl = wrapper.getAttribute('data-next-url');

  if (!nextUrl) return;

  fetch(nextUrl)
    .then(response => response.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Append ONLY new products
      const newProducts = doc.querySelectorAll('.product-grid .grid__item');
      const productGrid = document.querySelector('.product-grid');

      newProducts.forEach(product => {
        productGrid.appendChild(product);
      });

      // Update next URL correctly
      const newWrapper = doc.querySelector('.load-more-wrapper');
      if (newWrapper && newWrapper.dataset.nextUrl) {
        wrapper.setAttribute('data-next-url', newWrapper.dataset.nextUrl);
      } else {
        wrapper.remove(); // no more pages
      }
    });
});




jQuery(document).ready(function($){
  if(!$('.toggleMenu ul').is(":visible")){
    $('.toggleMenu h5').on('click',function(){
      let obj = $(this);
      if(obj.parent().find('ul').is(":visible")){
         obj.parent().find('ul').slideUp();
      }else{
         obj.parent().find('ul').slideDown();
      }
    });
  }

     if($('.accordion__content').length > 0 ){
       console.log($('.accordion__content').html().trim().length);
       if($('.accordion__content').html().trim().length < 1 ){
         $('.accordion__content').parent().parent().hide();
       }
      }

 
  $('.product__info-wrapper share-button').addClass('customShare');
  $('.product__info-wrapper .iwish-app-block-wrapper').addClass('customWish');
  
  if ($('.product-container').length) {
  var $thumbnailSlider = $('.thumbnail-slider');

    $thumbnailSlider.slick({
        vertical: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        arrows: true,
        infinite: true
    });
    $('.slick-next').html('<i class="fa fa-angle-right" aria-hidden="true"></i>');
     $('.slick-prev').html('<i class="fa fa-angle-left" aria-hidden="true"></i>');
  $thumbnailSlider.on('afterChange', function(event, slick, currentSlide) {
    const $currentSlide = $(slick.$slides[currentSlide]);

    // If the thumbnail contains a video template, inject it into the main active slide
    const $videoTemplate = $currentSlide.find('.zoom-video-template');
    if ($videoTemplate.length) {
      const $gallery = $currentSlide.closest('media-gallery');
      const $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
      if ($mainActive.length) {
        window.pauseAllMedia && window.pauseAllMedia();
        $mainActive.empty().append($videoTemplate.html());
      }
      return;
    }

    // Fallback: if data-zoom-video-url is provided, inject iframe
    const zoomVideoUrl = $currentSlide.attr('data-zoom-video-url') || $currentSlide.find('img').attr('data-zoom-video-url');
    if (zoomVideoUrl) {
      const $gallery = $currentSlide.closest('media-gallery');
      const $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
      if ($mainActive.length) {
        window.pauseAllMedia && window.pauseAllMedia();
        $mainActive.empty().append('<iframe src="' + zoomVideoUrl + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
      }
      return;
    }

    const newImageSrc = $currentSlide.find('img').attr('src');
    const newImageAlt = $currentSlide.find('img').attr('alt') || '';
    const $gallery = $currentSlide.closest('media-gallery');
    const $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
    if ($mainActive.length) {
      window.pauseAllMedia && window.pauseAllMedia();
      $mainActive.empty().append('<img width="" height="" src="' + newImageSrc + '" data-zoom-image="' + newImageSrc + '" alt="' + newImageAlt + '">');
    } else {
      $('.zoomed-image img').attr('src', newImageSrc).removeAttr('srcset');
    }
  });


  $('.product__media-item').each(function () {
  const $item = $(this);
  const $template = $item.find('template.zoom-video-template');

  if ($template.length && !$item.find('.zoom-video-poster-play-button').length) {

    const staticImageUrl = 'https://cdn.shopify.com/s/files/1/0662/3225/4640/files/play-btn.png?v=1766737294';


    $('<span class="zoom-video-poster-play-button">' +
        '<img src="' + staticImageUrl + '" alt="">' +
      '</span>').insertBefore($template);
  }
  });

   
    /*$thumbnailSlider.on('wheel', function(e) {
        if (e.originalEvent.deltaY > 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    });
   */
    $('.thumbnail-slider .product__media-item img').click(function() {
      var $slide = $(this).closest('.product__media-item');
      var $videoTemplate = $slide.find('.zoom-video-template');
      if ($videoTemplate.length) {
        var $gallery = $(this).closest('media-gallery');
        var $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
        if ($mainActive.length) {
          window.pauseAllMedia && window.pauseAllMedia();
          $mainActive.empty().append($videoTemplate.html());
        }
        return;
      }

      var zoomVideoUrl = $slide.attr('data-zoom-video-url') || $(this).attr('data-zoom-video-url');
      if (zoomVideoUrl) {
        var $gallery = $(this).closest('media-gallery');
        var $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
        if ($mainActive.length) {
          window.pauseAllMedia && window.pauseAllMedia();
          $mainActive.empty().append('<iframe src="' + zoomVideoUrl + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
        }
        return;
      }

      var newImageSrc = $(this).attr('src');
      var newImageAlt = $(this).attr('alt') || '';
      var $gallery = $(this).closest('media-gallery');
      var $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
      if ($mainActive.length) {
        window.pauseAllMedia && window.pauseAllMedia();
        $mainActive.empty().append('<img width="" height="" src="' + newImageSrc + '" data-zoom-image="' + newImageSrc + '" alt="' + newImageAlt + '">');
      } else {
        $('.zoomed-image img').attr('src', newImageSrc).removeAttr('srcset');
      }
    });

  }
  jQuery(document).on('click','.related-product-slider a', function(e) {
    e.preventDefault(); // prevent default action
    var url = jQuery(this).attr('href');
    window.open(url, '_blank');
  });
function related_products() {
 // console.log('@@@##');
  
    if (!jQuery('.related-product-slider').hasClass('owl-loaded')) {
         var script = document.createElement('script');
        script.src = "https://www.praavii.in/cdn/shop/t/2/assets/owl.carousel.js";
        script.onload = function () {
            jQuery('.related-product-slider').owlCarousel({
                loop: true,
                margin: 20,
                nav: true,
                autoplayTimeout: 5000,
                autoplay: false,
                responsive: {
                    0: { items: 2 },
                    600: { items: 2 },
                    768: { items: 3 },
                    1000: { items: 4 },
                    1366: { items: 4 }
                }
            });
        };
        document.head.appendChild(script);
        return true;
    }
    return false;
}
jQuery(window).on('scroll', related_products);
  setTimeout(function(){
   $watchandbuyheading = $('.whatmore-carousel-events>div:first-child>p').html();
    $('.whatmore-carousel-events>div:first-child>p').remove();
    $('.whatmore-carousel-events>div:first-child').html('<h2 class="text-center">'+$watchandbuyheading+'</h2>');
    /*
    *
    */
    var initialized = related_products();
       
  },2000);
  
  $('.search-popup').on('click',function(){
     $('.search-modal').show();
  });
 
  $('.announcments').owlCarousel({
    items: 1,               
    loop: true,             
    autoplay: true,        
    autoplayTimeout: 4000, 
    autoplayHoverPause:true,
    animateOut: 'slideUp',  
    animateIn: 'slideDown', 
    nav: false,           
    dots: false            
  });
  
  // $('.product-slider').owlCarousel({   uncomment to bring the new arrival slider back
  //     loop: true,
  //     margin: 20,
  //     nav: true,
  //     autoplayTimeout:5000,
  //     autoplayHoverPause:true,
  //     autoplay:true,
  //     responsive: {
  //         0: {
  //             items: 2
  //         },
  //         600: {
  //             items: 2
  //         },
  //         768: {
  //             items: 3
  //         },
  //         1000: {
  //           items: 4
  //       },
  //         1366: {
  //             items: 4
  //         }
  //     }
  // });

// $('#Trending-Now').owlCarousel({  uncomment for slider
//   loop: true,
//   margin: 20,
//   nav: true,
//   autoplayTimeout:5000,
//   autoplayHoverPause:true,
//   autoplay:true,
//   responsive: {
//       0: {
//           items: 2
//       },
//       600: {
//           items: 2
//       },
//       768: {
//           items: 3
//       },
//       1000: {
//         items: 4
//     },
//       1366: {
//           items: 4
//       }
//   }
// })

$('#Customer-Stories').owlCarousel({
  loop: true,
  margin: 20,
  nav: true,
  autoplayTimeout:5000,
  autoplayHoverPause:true,
  autoplay:true,
  responsive: {
      0: {
          items: 1
      },
      600: {
          items: 2
      },
      768: {
          items: 3
      },
      1000: {
        items: 4
    },
      1366: {
          items: 4
      }
  }
});
 /*  $('.magnifingimage').extm({
            position:'overlay'
       });
 image_zoom();
    $(document).on('click','.selectthumb',function(){
        $img = $(this).data('src');
        $('.videorender').remove();
        $('.magnifingimage').show().attr('src',$img);
        image_zoom();
    });
    $(document).on('click','.viewvideo',function(){
        $video = $(this).data('src');
        $('.videorender').remove();
        $('.magnifingimage').hide().after($video);
        //image_zoom();
    });
    function image_zoom(){
        $('.magnifingimage').extm({
            position:'overlay'
       });
    }*/
    $(".tab_content").hide();
    $(".tab_content:first").show();
    $("ul.tabs li").click(function() {
		
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();		
		
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

	  $(".tab_drawer_heading").removeClass("d_active");
	  $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
	  
    });
	$(".tab_drawer_heading").click(function() {
      
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $("#"+d_activeTab).fadeIn();
	  
	  $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
	  
	  $("ul.tabs li").removeClass("active");
	  $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });
	
	$('ul.tabs li').last().addClass("tab_last");
});

// shiprocket cart blinking text  and coupon text
function customizeShiprocketCart() {
    const root = document.querySelector('#shiprocket-smart-cart-root');

    if (!root?.shadowRoot) return;

    const shadow = root.shadowRoot;

    // Add style only once
    if (!shadow.querySelector('#custom-shiprocket-style')) {
        const style = document.createElement('style');
        style.id = 'custom-shiprocket-style';
        style.textContent = `
            .blink-single-text {
                display: none !important;
            }
        `;
        shadow.appendChild(style);
    }

    // Add coupon text only once
    const couponBox = shadow.querySelector('.sr-cart-coupon-box');

    if (couponBox && !shadow.querySelector('.custom-coupon-text')) {
        const p = document.createElement('p');
        p.className = 'custom-coupon-text';
        p.textContent = 'If you have any coupon code, please add it.';

        p.style.cssText = `
            margin: 12px 10px 6px;
            font-size: 14px;
            font-weight: 600;
            color: #333;
        `;

        couponBox.parentNode.insertBefore(p, couponBox);
    }
}

const interval = setInterval(() => {
    customizeShiprocketCart();

    const root = document.querySelector('#shiprocket-smart-cart-root');

    if (
        root?.shadowRoot?.querySelector('.sr-cart-coupon-box') &&
        root.shadowRoot.querySelector('#custom-shiprocket-style')
    ) {
        clearInterval(interval);
    }
}, 500);